import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_NAME,
} from '../constants/site';

/** Registered office block — use everywhere the company address appears. */
export default function CompanyAddress({
  className = '',
  as: Tag = 'address',
  showCompany = true,
}) {
  return (
    <Tag className={`fm-address ${className}`.trim()}>
      {showCompany && (
        <span className="fm-address__name">{COMPANY_NAME}</span>
      )}
      <span>{ADDRESS_LINE1}</span>
      <span>{ADDRESS_LINE2}</span>
    </Tag>
  );
}
